import React from 'react';
import { Box } from '@mui/material';
import { EntreprisesIntervenantWidget, EntreprisesIntervenantWidgetType } from '../../molecules';

export type EntreprisesIntervenantListProps = {
    items?: Array<EntreprisesIntervenantWidgetType>;
};

export const EntreprisesIntervenantList: React.FunctionComponent<EntreprisesIntervenantListProps> =
    function (props: EntreprisesIntervenantListProps) {
        const { items } = props;
        return (
            <Box>
                {items
                    ? items.map((itemProps: EntreprisesIntervenantWidgetType, index) => (
                          <EntreprisesIntervenantWidget
                              key={`entreprisesIntervenant-${itemProps.entreprisesIntervenant.entreprise.denomination}-${itemProps.entreprisesIntervenant.entreprise.siren}}`}
                              {...itemProps}
                              index={index}
                          />
                      ))
                    : null}
            </Box>
        );
    };
